<div class="library-form-btn">
  <hmd-empty-link v-if="isEdit " @click="showEditDrawer">编辑</hmd-empty-link>
  <a-button v-if="!isEdit " type="primary" @click="showCreateDrawer">
    <slot>新建材料</slot>
  </a-button>

  <a-drawer
    v-model:visible="visible"
    :width="780"
    :confirm-loading="createLoading || editLoading"
    :keyboard="false"
    :centered="true"
    :mask-closable="false"
    :destroyOnClose="true"
    :bodyStyle="{paddingBottom:'60px'}"
    @ok="submit"
    @cancel="closeDrawer"
  >
    <template #title>{{ isEdit ? "编辑" : "新建" }}材料</template>
    <a-skeleton :loading="detailLoading" active :paragraph="{rows:20}">
      <a-form layout="vertical">
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="材料名称" v-bind="validateInfos.name">
              <a-input
                v-model:value.trim="formRef.name"
                placeholder="请输入材料名称"
                allow-clear
                :maxlength="50"
              >
                <template #suffix>
                  <span class="text-grey">{{ formRef.name.length }}/50</span>
                </template>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="规格型号" v-bind="validateInfos.model">
              <a-input
                v-model:value.trim="formRef.model"
                placeholder="请输入规格型号"
                allow-clear
                :maxlength="1000"
              >
                <template #suffix>
                  <span class="text-grey">{{ formRef.model.length }}/1000</span>
                </template>
              </a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="所属分类" v-bind="validateInfos.materialCategoryId">
              <MaterialCategorySelectAdd
                v-model:value="formRef.materialCategoryId"
                @change="onMaterialCategoryChange"
              ></MaterialCategorySelectAdd>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结算单位" v-bind="validateInfos.unitId">
              <unit-select :addUnit="true" v-model:value="formRef.unitId"></unit-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="品牌" v-bind="validateInfos.materialCategoryBrandId">
              <brand-select
                v-model:value="formRef.materialCategoryBrandId"
                :category-id="formRef.materialCategoryId"
                :disabled="!formRef.materialCategoryId"
                v-model:brandList="formRef.brandList"
              ></brand-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="预算成本价(元)" v-bind="validateInfos.costPrice">
              <!-- <a-input-number
                class="w100"
                v-model:value="formRef.costPrice"
                :precision="2"
                :step="1"
                :min="0"
                :maxlength="14"
                placeholder="请输入"
              >
              </a-input-number> -->
              <number-input
                v-model:value="formRef.costPrice"
                class="w100"
                :maxLength="8"
                placeholder="请输入"
                :isEdit = isEdit
              ></number-input>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="10">
          <a-col :span="12">
            <a-form-item label="市场销售价(元)" v-bind="validateInfos.salesPrice">
              <!-- <a-input-number
                class="w100"
                v-model:value="formRef.salesPrice"
                :precision="2"
                :step="1"
                :min="0"
                placeholder="请输入"
                :maxlength="14"
              ></a-input-number> -->
              <number-input
                v-model:value="formRef.salesPrice"
                class="w100"
                placeholder="请输入"
                :maxLength="6"
                :isEdit = isEdit
              ></number-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="是否启用" v-bind="validateInfos.enable">
              <a-switch
                v-model:checked="formRef.enable"
                checked-children="启用"
                un-checked-children="禁用"
              ></a-switch>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item label="备注" v-bind="validateInfos.remark">
          <a-textarea
            v-model:value="formRef.remark"
            show-count
            placeholder="请输入说明，最多200字"
            :rows="4"
            :maxlength="200"
          >
          </a-textarea>
        </a-form-item>
        <a-form-item label="上传附件" v-bind="validateInfos.fileList">
          <attachment-table
            class="not-card"
            v-model:value="formRef.fileList"
            :allow-edit="true"
            :biz-id="id"
            biz-type="MATERIAL"
          ></attachment-table>
        </a-form-item>
      </a-form>
    </a-skeleton>
    <div class="ant-drawer-footer">
      <a-button @click="closeDrawer">取消</a-button>
      <a-button type="primary" @click="submit" :loading="createLoading || editLoading">
        确定
      </a-button>
    </div>
    <form-btn :showAddUnit="true"></form-btn>
  </a-drawer>
</div>
